import React, { useCallback, useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { LocalDateUtil } from '@xengage/gw-portals-util-js';
import { EnrollmentService } from 'gw-capability-policyenrollment';
import { ModalNextContext } from '@jutro/components';
import { LoaderExt } from 'gw-components-platform-react';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { useTranslator } from '@jutro/locale';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import moment from 'moment';
import {
    withViewModelService,
    ViewModelForm,
} from '@xengage/gw-portals-viewmodel-react';
import usecpmiAnalytics from '../../../hooks/usecpmiAnalytics';
import metadata from './AutomaticPaymentPage.metadata.json5';
import messages from './AutomaticPaymentPage.messages';
import styles from './AutomaticPaymentPage.module.scss';
import useGoogleAnalytics from '../../../hooks/useGoogleAnalytics';

function AutomaticPaymentPage(props) {
    const [outstandingAmount, setOutStandingAmount] = useState();
    const [checkCancel, setCheckCancel] = useState(false);   
    const translator = useTranslator();
    const ModalNext = useContext(ModalNextContext);
    const [trackPageView] = usecpmiAnalytics();
    const [trackGAPageView] = useGoogleAnalytics();

    const { AccountBillingDetailsService: BillingService } = useDependencies(
        'AccountBillingDetailsService'
    );
    console.log(props);

    const { authHeader, viewModelService, history } = props;

    const accountVM = viewModelService.create(
        {},
        'bc',
        'edge.capabilities.billing.dto.AccountBankDetailsDTO'
    );

    const [accountDetailsVM, setAccountDetailsVM] = useState(accountVM);
    const [abavalid, setabaValid] = useState(false);
    const [accountNumbervalid, setAccountNumberValid] = useState(false);
    const [accNumber,setAccNumber]=useState('');
    const[accConfirmNumber,setAccConfirmNumber]=useState('');
    const [checkBox, setCheckBox] = useState(false);
    const [bankFinance, setBankFinance] = useState(false);
    const [banknameValid, setBankNameValid] = useState(false);
    const [enrollmentData,setEnrollmentData]=useState({});
    const [accountName,setAccountName]=useState();
    const [accountNum,setAccountNum]=useState();

    const [isLoading, setLoadingState] = useState(true);
    const [multiStreamDropdownItemst,setMultiStreamDropdownItemst] = useState(props?.history?.location?.state?.multiInvoiceStreamData);
    const [invoiceStreamId,setInvoiceStreamId] = useState(props?.history?.location?.state?.multiInvoiceSelectedValue);
    const [invoiceStreamName,setInvoiceStreamName] = useState();

    // GCD-2831 - per stream, not per account: a payment already drafting on this
    // stream blocks cancellation even when the account's other streams are clear.
    const hasPaymentDueToday = props?.history?.location?.state?.data?.allInvoiceStreamDetails
        ?.find((item) => item.internalId === invoiceStreamId)?.hasPaymentDueToday ?? false;

    useEffect(()=>{
        props?.history?.location?.state?.data?.allInvoiceStreamDetails.map((item)=>{
            if(item.internalId ===invoiceStreamId){
                setInvoiceStreamName(item.displayName);
            }
        })
    },[invoiceStreamId, props?.history?.location?.state?.data])
    
    useEffect(() => {
        const data = [];
        const accountNumber = props?.location?.state?.accountNumber;
        const paymentMode=props?.history?.location?.state?.type;

        data.push(paymentMode);  
        data.push(accountNumber);
        
       
        EnrollmentService.getUser(props?.userInfo?.email,authHeader)
            .then((result) => {
                setEnrollmentData(result);
                setLoadingState(false);
                result.accountInformation.map((item)=>{
                    if(item.accountNumber===accountNumber){
                        setAccountNum(item.accountNumber)
                        setAccountName(item.accountName)
                    }
                })
            } )

        // BillingService.fetchOutstandingAmount(data, authHeader).then((res) => {
        //     setOutStandingAmount(res.amount);
        // });
        let streamName;
        props?.history?.location?.state?.data?.allInvoiceStreamDetails.map((item)=>{
            if(item.internalId ===invoiceStreamId){
                streamName = item.displayName;
            }
        })
        
        
        data.push(streamName);
        BillingService.fetchOutstandingInvoiceStreamAmount(data, authHeader).then((res) => {
            setOutStandingAmount(res.amount);
        });
              
       
    }, [BillingService, authHeader, invoiceStreamId, invoiceStreamName, multiStreamDropdownItemst, props?.history?.location?.state?.type, props?.location?.state?.accountNumber, props?.userInfo?.email]);

   

    useEffect(() => {
        trackGAPageView("/automatic-payment","Automatic Payment")
    },[])

    useEffect(() => {
        trackPageView("Automatic Payment","/automatic-payment");
    }, []);

    const setUpAutomaticPayment = useCallback(() => {
        
        setLoadingState(true);
        const accountDetails = {
            amountPaid: {
                currency: 'usd',
                amount: 0.0,
            },
            paymentInstrument: {
                bankAccountData: accountDetailsVM.value,
                creditCardData: null,
                paymentMethod: 'wire',
            },
            invoiceStreamId: invoiceStreamId,
            invoiceStreamName:invoiceStreamName
        };
        
        if(props?.history?.location?.state?.data?.basicDetails?.enrolledForAutomticPayment)
        {
           
            BillingService.updateAutomaticPayment(accountDetails,accountNum, authHeader)
                .then((res) => {
                    // console.log(res);
                })
                .then(() => {
                    setLoadingState(false);
                    ModalNext.showAlert({
                        message: (
                            <span className={styles.popUp}>
                                {translator(messages.updateMessage)}
                            </span>
                        ),
                        confirmButtonText: 'OK',
                    });
                })
                .then((res) => {
                    return history.push({
                        pathname: '/billing-summary',
                        state: {
                            message: 'AutomaticPaymentUpdated',
                            accountNum: accountDetailsVM?.value?.bankAccountNumber,
                            invoiceStreamID:invoiceStreamId,
                            invoiceStreamName:invoiceStreamName
                        },
                    });
                });
        }
        else{
            BillingService.enableAutomaticPayment(accountDetails, accountNum,authHeader)
                .then((res) => {
                // console.log(res);

                })
                .then(() => {
                    setLoadingState(false);
                    ModalNext.showAlert({
                        message: (
                            <span className={styles.popUp}>
                                {translator(messages.setupMessage)}
                            </span>
                        ),
                        confirmButtonText: 'OK',
                    });
                })
                .then((res) => {
                    return history.push({
                        pathname: '/billing-summary',
                        state: {
                            message: 'AutomaticPaymentSetUpDone',
                            accountNum: accountDetailsVM?.value?.bankAccountNumber,
                            invoiceStreamID:invoiceStreamId,
                            invoiceStreamName:invoiceStreamName
                        },
                    });
                });

        }

        
    }, [accountDetailsVM.value, invoiceStreamId, invoiceStreamName, props?.history?.location?.state?.data?.basicDetails?.enrolledForAutomticPayment, BillingService, accountNum, authHeader, ModalNext, translator, history]);


    

   

    const cancelChange = useCallback(() => {
        // history.go(-1);
        history.push({
            pathname:`/billing-summary`,
            state:{
            PaymentCanceled:"PaymentCanceled",
            invoiceStreamID:props?.history?.location?.state?.multiInvoiceSelectedValue
        }
            
        })
    }, [history, props?.history?.location?.state?.multiInvoiceSelectedValue]);

    const CancelAutomaticPayment = useCallback(() => {
        setLoadingState(true);

        const accountNumber = props?.location?.state?.accountNumber;

        BillingService.disableAutomaticPayment(accountNumber,invoiceStreamName, authHeader)
            .then((res) => {
                setLoadingState(false);
                
            })
            .then(() => {
                ModalNext.showAlert({
                    message: (
                        <span className={styles.popUp}>
                            {translator(messages.cancelMessage)}
                        </span>
                    ),
                    confirmButtonText: 'OK',
                });
            })
            .then((res) => {
                return history.push({
                    pathname: '/billing-summary',
                    state: {
                        message: 'AutomaticPaymentModeCancelled',
                        invoiceStreamID:invoiceStreamId,
                    },
                });
            });
    }, [props?.location?.state?.accountNumber, BillingService, invoiceStreamName, authHeader, ModalNext, translator, history, invoiceStreamId]);

    const getEnrollText = useCallback(() => {

        let amount = outstandingAmount    
        const effectiveDate=(moment(LocalDateUtil.today()).format('MM/DD/YYYY'));
        if(amount>0)
        {
            amount = amount.toLocaleString("en-US", {style:"currency", currency:"USD"})
            return (
                <>
                    <div className={styles.EnrollmentText}>
                        {`Enrollment will be effective on ${effectiveDate}. You have an outstanding amount of ${amount} 
                    that must be satisfied by a one-time payment by check, credit card, or ACH/EFT.`}
                    </div>
                    <br/>
                    
                </>
            );
        }
        return (
            <>
                <div className={styles.EnrollmentText}>
                    {`Enrollment will be effective on ${effectiveDate}.`}
                </div>
                <br/>
                
            </>
        );      
    }, [outstandingAmount, props?.history?.location?.state?.data]);

    const getEnrollmentText=useCallback(()=>{
        return (
            <>
                <div className={styles.enrollmentText}>
                    {`Enrollment update will be in effect only for the account named below:`}
                </div>
                <div className={styles.accountNumberAndName}> 
                    <div>{accountName}</div>
                    <div>{accountNum}</div>
                    <div>{props?.history?.location?.state?.data?.allInvoiceStreamDetails?.length > 1 && invoiceStreamName}</div>
                </div>
                <br/>
            </>
        );    
    })

    const getUpdateText = useCallback(() => {

        
        const amount = outstandingAmount;
        const pastDue= props?.history?.location?.state?.data?.allInvoiceStreamDetails.find((item) => item.internalId === invoiceStreamId)?.pastDueAmount?.amount//props?.history?.location?.state?.data?.basicDetails?.pastDue?.amount;
        const Today=moment(props?.history?.location?.state?.data?.effectiveDate).format('MM/DD/YYYY');
        const  outStandingAmount = amount.toLocaleString("en-US", {style:"currency", currency:"USD"})
        const pastDueAmount=pastDue.toLocaleString("en-US", {style:"currency", currency:"USD"})

        return (
            <>
                <div className={styles.EnrollmentText}>
                    <span>{`Enrollment will be effective on ${Today}.`}</span>
                    <span>{amount>0 ? `The outstanding amount of ${outStandingAmount} will be processed using your prior bank information.`: ''}</span>
                    <span>{pastDue>0 ? `You have a past due amount of ${pastDueAmount} that must be satisfied by a one-time payment by check, credit card, or ACH/EFT.` : ''}</span>
                </div>
                
                
            </>
        );
        
           
        
           
    }, [invoiceStreamId, outstandingAmount, props?.history?.location?.state?.data?.allInvoiceStreamDetails, props?.history?.location?.state?.data?.basicDetails?.pastDue?.amount, props?.history?.location?.state?.data?.effectiveDate]);

    const getButtonStatus = useCallback(() => {
       
        if (
            checkBox &&
            abavalid &&
            accountNumbervalid &&
            bankFinance &&
            banknameValid &&
            accNumber===accConfirmNumber
        ) {
            return false;
        }
        return true;
    }, [abavalid, accConfirmNumber, accNumber, accountNumbervalid, bankFinance, banknameValid, checkBox]);

    const cancelText = useCallback(() => {

        const amount = outstandingAmount;
        // const effectiveDate=moment(props?.history?.location?.state?.data?.effectiveDate).format('MM/DD/YYYY');
        const effectiveDate=(moment(LocalDateUtil.today()).format('MM/DD/YYYY'));
        const isElgibleForUnEnrollForBilledAmount=props?.history?.location?.state?.data?.isElgibleForUnEnrollForBilledAmount
        const  outStandingAmount = amount.toLocaleString("en-US", {style:"currency", currency:"USD"})
        return (
            <>
                <div style={{ paddingTop: '30px' }}>
                    <span className={styles.cancelText}>
                        {translator(messages.cancelPaymenttext1)}
                    </span>
                    <span className={styles.EnrollmentText}>
                        {`Terminations will be effective  from ${effectiveDate}. `}
                    </span>
                    
                    <span className={styles.cancelText}>
                        {isElgibleForUnEnrollForBilledAmount ? translator(messages.cancelPaymenttext2):''}
                    </span>
                    
                    <br/>
                    <br/>
                    
                    <span
                        className={styles.EnrollmentText}
                    >{amount>0 ?`You have an outstanding amount of ${outStandingAmount} that must be satisfied by a one-time payment by check, credit card, or ACH/EFT.`:''}</span>

                    {hasPaymentDueToday ? (
                        <>
                            <br/>
                            <br/>
                            <span className={styles.EnrollmentText}>
                                {translator(messages.paymentInProgress)}
                            </span>
                        </>
                    ) : ''}
                </div>
            </>
        );
    }, [outstandingAmount, props?.history?.location?.state?.data, translator, hasPaymentDueToday]);
    

    const getAccountHolderEmail = useCallback(() => {
        if (!_.isEmpty(enrollmentData)) {
            return enrollmentData?.emails[0]?.value;
        }

        return ' ';
    }, [enrollmentData]);

    const getAccountHolderACNo = useCallback(() => {
        if (!_.isEmpty(enrollmentData)) {
            return accountNum;
        }

        return ' ';
    }, [accountNum, enrollmentData]);

    const getAccountHolderCompanyName = useCallback(() => {
        if (!_.isEmpty(enrollmentData)) {
            return accountName;
        }

        return ' ';
    }, [accountName, enrollmentData]);

    const getAccountHolderName = useCallback(() => {
        if (!_.isEmpty(enrollmentData)) {
            return `${enrollmentData.name.givenName} ${enrollmentData?.name?.familyName}`;
        }
        (' ');
    }, [enrollmentData]);

    

    const checkABA = (value) => {
        if (value) {
            let i;
            let n;
            let t;
            t = '';
            for (i = 0; i < value.length; i++) {
                const c = parseInt(value.charAt(i), 10);
                if (c >= 0 && c <= 9) t += c;
            }
            if (t.length !== 9) return false;
            n = 0;
            for (i = 0; i < t.length; i += 3) {
                n +=
                    parseInt(t.charAt(i), 10) * 3 +
                    parseInt(t.charAt(i + 1), 10) * 7 +
                    parseInt(t.charAt(i + 2), 10);
            }
            if (n !== 0 && n % 10 === 0) {
                return true;
            }
            return false;
        }
        return false;
    };

    const handleValidation = useCallback((value, path) => {
        if (path === 'bankABANumber') {
            const valid = checkABA(value);
            setabaValid(valid);
        }
        if (path === 'bankFinanceName') {
            if (value.length > 0) {
                setBankFinance(true);
            }
        }
        if (path === 'bankName') {
            if (value.length > 0) {
                setBankNameValid(true);
            }
        } if (path === 'bankAccountNumber') {
            if (value.length >= 4 && value.length <= 17)  {
                setAccountNumberValid(true);
                setAccNumber(value);
            } else {
                setAccountNumberValid(false);
            }
        }else if(path==='bankAccountNumberConfirmation'){
            setAccConfirmNumber(value);
        }
    }, []);

    const writeValue = useCallback(
        (value, path) => {
            handleValidation(value, path);
            const newAccountDetailsVM = viewModelService.clone(
                accountDetailsVM
            );
            _.set(newAccountDetailsVM, path, value);
            setAccountDetailsVM(newAccountDetailsVM);
        },
        [accountDetailsVM, handleValidation, viewModelService]
    );

    if (isLoading) {
        // eslint-disable-next-line react/react-in-jsx-scope
        return <LoaderExt loaded={!isLoading} />;
    }
    const overrides = {
        '@field': {
            labelPosition: 'left',
            phoneWide: {
                labelPosition: 'top',
            },
        },
        staticText: {
            visible:!props?.location?.state?.data?.basicDetails?.enrolledForAutomticPayment,
            content: getEnrollText(),
        },
        staticUpdateText:{
            content:getUpdateText(),
            visible:props?.location?.state?.data?.basicDetails?.enrolledForAutomticPayment,
        },
        canceltext: {
            content: cancelText(),
        },
        automaticPageContainer: {
            visible: props?.location?.state?.page === 'automaticsetup',
        },
        pageTitleId:{
            visible:!props?.location?.state?.data?.basicDetails?.enrolledForAutomticPayment
        },
        changePageTitleId:{
            visible:props?.location?.state?.data?.basicDetails?.enrolledForAutomticPayment 
        },
        cancelContainer: {
            visible: props?.location?.state?.page === 'cancelpayment',
        },
        CancelPagecheckBox: {
            onValueChange: (value) => setCheckCancel(value),
            value: checkCancel,
        },
        cancelPageSubmit: {
            disabled: !checkCancel || hasPaymentDueToday,
        },
        accountHolderName: {
            value: getAccountHolderName(),
        },
        accountHolderEmail: {
            value: getAccountHolderEmail(),
        },
        accountHolderAccount: {
            value: getAccountHolderACNo(),
        },
        CompanyNameId: {
            value: getAccountHolderCompanyName(),
        },
        mismatchWarning: {
            visible:
                accountDetailsVM?.value?.bankAccountNumber !==
                accountDetailsVM?.value?.bankAccountNumberConfirmation,
        },
        checkBoxId: {
            onValueChange: (value) => setCheckBox(value),
            value: checkBox,
        },
        submitButton: {
            disabled: getButtonStatus(),
        },
        enrollmentMessageText:{
            content:getEnrollmentText()
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            cancelChange,
            setUpAutomaticPayment,
            CancelAutomaticPayment,
            writeValue,
        },
        resolveClassNameMap: styles,
    };

    return (
        <ViewModelForm
            model={accountDetailsVM}
            uiProps={metadata.pageContent}
            overrideProps={overrides}
            onValueChange={writeValue}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

AutomaticPaymentPage.propTypes = {
    history: PropTypes.shape({
        location: PropTypes.shape({
            state: PropTypes.shape({
                redirectPath: PropTypes.string.isRequired,
            }).isRequired,
        }).isRequired,
        push: PropTypes.func.isRequired,
    }).isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            claimNumber: PropTypes.string.isRequired,
        }),
    }).isRequired,
    viewModelService: PropTypes.shape({
        create: PropTypes.func,
    }).isRequired,
};

export default withRouter(
    withViewModelService(withAuthenticationContext(AutomaticPaymentPage))
);
